<template>
  <button class="theme-btn" @click="toggleTheme">
    <svg width="24" height="24" viewBox="0 0 24 24">
      <path v-if="isDarkMode" :d="mdiWeatherSunny" />
      <path v-else :d="mdiWeatherNight" />
    </svg>
  </button>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { mdiWeatherSunny, mdiWeatherNight } from '@mdi/js';

export default {
  name: 'ThemeToggle',
  computed: {
    ...mapState(['isDarkMode'])
  },
  methods: {
    ...mapMutations(['toggleTheme'])
  },
  data() {
    return {
      mdiWeatherSunny,
      mdiWeatherNight
    };
  }
};
</script>

<style scoped>
.theme-btn {
  position: fixed;
  top: 12px;
  right: 12px;
  padding: 4px;
  border: none;
  cursor: pointer;
  color: var(--text-color);
  display: flex;
  align-items: center;
  background: none;
  justify-content: center;
  z-index: 1200;
  outline: none;
  background-color: var(--surface-color);
  border-radius: 50%;
  -webkit-tap-highlight-color: transparent;
}

.theme-btn:hover {
  background-color: var(--primary-hover);
  border-radius: 50%;
}

.theme-btn svg {
  width: 24px;
  height: 24px;
  fill: currentColor;
}
</style>